import { render, staticRenderFns } from "./PatientGeneralInfosModal.vue?vue&type=template&id=13d88338&scoped=true"
import script from "./PatientGeneralInfosModal.vue?vue&type=script&lang=js"
export * from "./PatientGeneralInfosModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d88338",
  null
  
)

export default component.exports